import { useContactDetailsStore } from '@/shared/stores/ContactDetailStore';
import { PHONES_CONTACTS, ADDITIONAL_CONTACTS, CONTACTS } from '@/shared/constants/ContactType';
import { ContactDetailType, type ContactDetail } from '@shared/types/ContactDetail';
import { PhoneNumberHelper } from '@/shared/helper/PhoneNumberHelper';
import { sortElementArray } from '../utils/SortElementArray';

export const ContactHelper = () => {
  const { substringPhoneNumbers } = PhoneNumberHelper();

  const cleanUpContact = (contact: ContactDetail) =>
    Object.entries(contact)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .reduce(
        (obj, [key, value]) => ({
          ...obj,
          [key]: PHONES_CONTACTS.includes(key as CONTACTS) ? substringPhoneNumbers(value) : value,
        }),
        {} as ContactDetail
      );

  const modifiedContactList = (contactList: ContactDetail[]) => {
    const activeContacts = contactList.filter((c) => c.visible).map(cleanUpContact);
    return sortElementArray(
      activeContacts,
      'id',
      activeContacts.find((contact) => contact.type === ContactDetailType.BUSINESS)?.id || activeContacts[0].id
    );
  };

  const getMatchedContacts = <T extends keyof ContactDetail>(idx: number, keys: T[]): Pick<ContactDetail, T> => {
    const { modifiedContactDetails } = useContactDetailsStore();
    const contact = modifiedContactDetails[idx];
    const matchedContacts: Partial<ContactDetail> = {};

    for (const key of keys) {
      if (contact && key in contact) {
        matchedContacts[key] = contact[key];
      }
    }

    return matchedContacts as Pick<ContactDetail, T>;
  };

  const phoneNumbers = (idx: number): Partial<ContactDetail> => getMatchedContacts(idx, PHONES_CONTACTS);
  const otherContacts = (idx: number): Partial<ContactDetail> => getMatchedContacts(idx, ADDITIONAL_CONTACTS);

  return {
    phoneNumbers,
    otherContacts,
    modifiedContactList,
  };
};
